const httpStatus = Object.freeze({
  INTERNAL_SERVER_ERROR: 500,
  NOT_FOUND: 404,
  OK: 200
})

export { httpStatus }
